<template>
        <div class="d-flex align-items-center mr-2">
            <animal-avatar :thumbnail-absolute-path="getDescriptionObject['thumbnail']"
                           :species="getDescriptionObject['species']" class="m-1"/>
            <span class="mr-2 text-wrap">{{ getFullName }}</span>
        </div>
</template>

<script>
import AnimalAvatar from "@/pages/AppPages/Animals/AnimalAvatar.vue";

export default {
    name: "AnimalDropdownItem",
    components: {AnimalAvatar},
    props: {
        animal: { type: Object, default: () => { return {} } }
    },
    computed: {
        getDescriptionObject() {
            if (this.animal.hasOwnProperty('descriptionObject')) {
                return this.animal.descriptionObject
            }
            if (this.animal.hasOwnProperty('description_object')) {
                return this.animal['description_object']
            }
            return {}
        },
        getFullName() {
            if (this.animal.hasOwnProperty('fullName')) {
                return this.animal.fullName
            }
            if (this.animal.hasOwnProperty('full_name')) {
                return this.animal['full_name']
            }
            return null
        }
    }
}
</script>

<style scoped>

</style>